import { ChakraGrid } from '@equip.health/ui';

import { AdminRoutes } from './AdminRoutes';
import AdminNav from '../components/common/navbar/AdminNav';
import Page from '../components/common/Page';
import { ComponentPortalContextProvider } from '../lib/contexts/ComponentPortalContext';

const AdminApp = () => (
  <ComponentPortalContextProvider>
    <ChakraGrid
      columnGap="24px"
      height="100%"
      templateColumns="auto 1fr"
      templateRows="1fr"
      width="100%"
    >
      <AdminNav />
      <Page>
        <AdminRoutes />
      </Page>
    </ChakraGrid>
  </ComponentPortalContextProvider>
);

export default AdminApp;
